import { render, staticRenderFns } from "./NewDash.vue?vue&type=template&id=9ba44f7a&"
import script from "./NewDash.vue?vue&type=script&lang=js&"
export * from "./NewDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports